import axios, { AxiosResponse } from "axios";
import axiosInstance from "../../../../interceptors/axiosInstance";
import { Tasa, TasaCrear, TasaEditar } from "../models/tasa";


const crearTasa = async (data: TasaCrear) => {    
    const response: AxiosResponse = await axiosInstance.post(`siscred-api-maestros/v1/tasa/crear`, data);
    
    return response;

};

const editarTasa = async (data: TasaEditar) => {
    const response: AxiosResponse = await axiosInstance.put(`siscred-api-maestros/v1/tasa/actualizar/${data.id}`, data);
    
    return response;
};

const eliminarTasa = async (id: number) => {
    const response: AxiosResponse = await axiosInstance.delete(`siscred-api-maestros/v1/tasa/eliminar/${id}`);
    return response;
}

export {
    crearTasa,
    editarTasa,
    eliminarTasa
}